{
  "Clear search": "Notīrīt meklēšanu"
}
